// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles and resets for Law Enforcement Portal */

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: var(--dst-text, #1f2937);
  background: var(--dst-bg, #ffffff);
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  line-height: 1.2;
}

p {
  margin: 0;
}

button {
  font-family: inherit;
  cursor: pointer;
}

input, select, textarea {
  font-family: inherit;
  font-size: inherit;
}

a {
  color: var(--dst-primary, #205ec8);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Focus styles for accessibility */
:focus-visible {
  outline: 2px solid var(--dst-primary, #205ec8);
  outline-offset: 2px;
}

/* Reduce motion for users who prefer it */
@media (prefers-color-scheme: dark) {
  html, body {
    background: var(--dst-bg, #0f172a);
    color: var(--dst-text, #e5e7eb);
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/styles/global.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE;IACE,kCAAkC;IAClC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;EAClC;AACF","sourcesContent":["/* Global styles and resets for Law Enforcement Portal */\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--dst-text, #1f2937);\n  background: var(--dst-bg, #ffffff);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 0;\n  line-height: 1.2;\n}\n\np {\n  margin: 0;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n}\n\ninput, select, textarea {\n  font-family: inherit;\n  font-size: inherit;\n}\n\na {\n  color: var(--dst-primary, #205ec8);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n/* Focus styles for accessibility */\n:focus-visible {\n  outline: 2px solid var(--dst-primary, #205ec8);\n  outline-offset: 2px;\n}\n\n/* Reduce motion for users who prefer it */\n@media (prefers-color-scheme: dark) {\n  html, body {\n    background: var(--dst-bg, #0f172a);\n    color: var(--dst-text, #e5e7eb);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation: none !important;\n    transition: none !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
